<template>
	<div class="">
		<vm-header></vm-header>
		<div class="result">
			<div class="container-fluid">
				<div class="container">
					<div class="row">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<div class="info">
								<div class="title">
									<img src="../images/user/line.png" alt=""> 测评结果
								</div>
								<div class="detail">
									<div class="item1">
										<div class="l">
											<span class="bold">省市：</span>
											<span class="text">河北省邯郸市</span>
											<span class="bold">类型：</span>
											<span class="text">理科</span>
										</div>
										<div class="r">
											创建时间：2021-11-21 12:21:10
										</div>
									</div>
									<div class="item2">
										<div>
											<span class="bold">专业：</span>
											<span class="text">经济与金融、金融学</span>
										</div>
									</div>
									<div class="item3">
										<div>
											<span class="bold">测评结果：</span>
											<span class="text">评价内容评价内容评价内容评价内容评价内容评价内容评价内容评价内容评价内容评价内容评价内容评价内容</span>
										</div>
									</div>
								</div>
								<div class="chart">
									<div class="title">
										<div class="l"><img src="../images/user/line.png" alt=""> 选考科目及对应可报专业情况</div>
										<div class="r">
											<div class="item1"><div></div>	人数</div>
											<div class="item2"><div></div>	比例</div>
										</div>
									</div>
									<!-- <div class="content" ref="main"></div> -->
									<result></result>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<item7></item7>
	</div>
</template>

<script>
	import result from "../tubiao/wodexuanke.vue"
	import vmHeader from '../../components/vmHeader.vue'
	import item7 from '../../components/item7.vue'
	export default {
		name: "",
		components: {
			vmHeader,
			item7,
			result
		},
		data() {
			return {}
		},
		methods: {
			
		}


	}
</script>

<style scoped>
	.result .info{background-color: #fff;box-sizing: border-box;}
	.result .info>.title{color: #29A7E1;font-size: 14px;line-height: 16px;border-bottom: 1px solid rgba(0, 0, 0, 0.1);padding-bottom:15px;}
	.result .info>.title>img{width: 5px;height: 18px;margin-right: 10px;}
	
	.result .info>.detail{padding: 10px;border: 1px solid rgba(0, 0, 0, 0.10);border-radius: 5px;box-sizing: border-box;}
	.result .info>.detail>div{margin: 10px 0px;}
	.result .info>.detail>.item1{display: flex;justify-content: space-between;flex-wrap: wrap;}
	.result .info>.detail>.item1>.l>.bold{font-weight: bold;color: #333333;font-size: 12px;}
	.result .info>.detail>.item1>.l>.text{color: #666666;font-size: 12px;margin-right: 10px;}
	.result .info>.detail>.item1>.r{color: #999999;font-size: 12px;}
	.result .info>.detail>.item2{}
	.result .info>.detail>.item2>div>.bold{font-weight: bold;color: #333333;font-size: 12px;}
	.result .info>.detail>.item2>div>.text{color: #666666;font-size: 12px;margin-right: 80px;}
	.result .info>.detail>.item3{}
	.result .info>.detail>.item3>div{display: flex;}
	.result .info>.detail>.item3>div>.bold{font-weight: bold;color: #333333;font-size: 12px;flex-shrink: 0;}
	.result .info>.detail>.item3>div>.text{color: #666666;font-size: 12px;}
	
	.result .info>.chart{margin-top: 30px;}
	.result .info>.chart>.title{display: flex;justify-content: space-between;flex-wrap: wrap;}
	.result .info>.chart>.title>.l{color: #29A7E1;font-size: 14px;}
	.result .info>.chart>.title>.l>img{width: 5px;height: 18px;margin-right: 10px;}
	.result .info>.chart>.title>.r{display: flex;}
	.result .info>.chart>.title>.r>div{display: flex;font-size:12px ;color: #333333;align-items: center;}
	.result .info>.chart>.title>.r>div>div{width: 30px;height: 16px;border-radius: 5px;margin-right: 6px;}
	.result .info>.chart>.title>.r>.item1{margin-right: 6px;}
	.result .info>.chart>.title>.r>.item1>div{background-color: #29A7E1;}
	.result .info>.chart>.title>.r>.item2>div{background-color: #FE9603;}
	.result .info>.chart>.content{width: 100%;height: 421px;}
	
	
	.result .info>.chart>.title>.r{margin-top: 20px;}
	@media (min-width: 768px) {
		
		.result .center{background-color: #FBFBFB;}
		.result .detail{}
		.result .detail>.img{background-color: #fff;padding: 25px 0px 20px 0px;margin-bottom: 10px;}
		.result .detail>.img>img{width: 102px;height: 102px;border-radius: 50%;display: block;margin: 0px auto;}
		.result .detail>.img>.text{text-align: center;color: #333333;font-size: 16px;}
		.result .detail>.list{padding: 20px 0px 20px 0px;background-color: #fff;}
		.result .detail>.list>.item{display: flex;height: 60px;align-items: center;padding-left: 22px;box-sizing: border-box;width: 100%;cursor: pointer;border-left: 2px solid #00000000;transition: 0.3s;}
		.result .detail>.list>.active{background-color: #FBFBFB;border-left: 2px solid #F53824;}
		.result .detail>.list>.item>img{width: 44px;height: 44px;margin-right: 10px;}
		.result .detail>.list>.item>.text{font-size: 16px;color: #666;}
		.result .detail>.list>.item>.num{width: 28px;height: 23px;font-size: 16px;color: #fff;background-image: url("../images/user/label.png");background-size: 100% 100%;background-repeat: no-repeat;text-align: center;line-height: 20px;margin-left: 10px;}
		
		.result .info{background-color: #fff;padding: 20px;box-sizing: border-box;}
		.result .info>.title{color: #29A7E1;font-size: 20px;line-height: 24px;border-bottom: 1px solid rgba(0, 0, 0, 0.1);padding-bottom:20px;}
		.result .info>.title>img{width: 7px;height: 24px;margin-right: 10px;}
		
		.result .info>.detail{height: 151px;padding: 20px;border: 1px solid rgba(0, 0, 0, 0.10);border-radius: 5px;box-sizing: border-box;}
		.result .info>.detail>div{margin: 8px 0px;}
		.result .info>.detail>.item1{display: flex;justify-content: space-between;}
		.result .info>.detail>.item1>.l>.bold{font-weight: bold;color: #333333;font-size: 16px;}
		.result .info>.detail>.item1>.l>.text{color: #666666;font-size: 16px;margin-right: 80px;}
		.result .info>.detail>.item1>.r{color: #999999;font-size: 16px;}
		.result .info>.detail>.item2{}
		.result .info>.detail>.item2>div>.bold{font-weight: bold;color: #333333;font-size: 16px;}
		.result .info>.detail>.item2>div>.text{color: #666666;font-size: 16px;margin-right: 80px;}
		.result .info>.detail>.item3{}
		.result .info>.detail>.item3>div{display: flex;}
		.result .info>.detail>.item3>div>.bold{font-weight: bold;color: #333333;font-size: 16px;flex-shrink: 0;}
		.result .info>.detail>.item3>div>.text{color: #666666;font-size: 16px;}
		
		.result .info>.chart{margin-top: 30px;}
		.result .info>.chart>.title{display: flex;justify-content: space-between;}
		.result .info>.chart>.title>.l{color: #29A7E1;font-size: 20px;line-height: 24px;}
		.result .info>.chart>.title>.l>img{width: 7px;height: 24px;margin-right: 10px;}
		.result .info>.chart>.title>.r{display: flex;}
		.result .info>.chart>.title>.r>div{display: flex;font-size:16px ;color: #333333;align-items: center;}
		.result .info>.chart>.title>.r>div>div{width: 36px;height: 20px;border-radius: 5px;margin-right: 6px;}
		.result .info>.chart>.title>.r>.item1{margin-right: 50px;}
		.result .info>.chart>.title>.r>.item1>div{background-color: #29A7E1;}
		.result .info>.chart>.title>.r>.item2>div{background-color: #FE9603;}
		.result .info>.chart>.content{width: 100%;height: 421px;}
	}
	@media (min-width: 992px) {
		.result .center{background-color: #FBFBFB;}
		.result .detail{}
		.result .detail>.img{background-color: #fff;padding: 25px 0px 20px 0px;margin-bottom: 10px;}
		.result .detail>.img>img{width: 102px;height: 102px;border-radius: 50%;display: block;margin: 0px auto;}
		.result .detail>.img>.text{text-align: center;color: #333333;font-size: 16px;}
		.result .detail>.list{padding: 20px 0px 20px 0px;background-color: #fff;}
		.result .detail>.list>.item{display: flex;height: 60px;align-items: center;padding-left: 22px;box-sizing: border-box;width: 100%;cursor: pointer;border-left: 2px solid #00000000;transition: 0.3s;}
		.result .detail>.list>.active{background-color: #FBFBFB;border-left: 2px solid #F53824;}
		.result .detail>.list>.item>img{width: 44px;height: 44px;margin-right: 10px;}
		.result .detail>.list>.item>.text{font-size: 16px;color: #666;}
		.result .detail>.list>.item>.num{width: 28px;height: 23px;font-size: 16px;color: #fff;background-image: url("../images/user/label.png");background-size: 100% 100%;background-repeat: no-repeat;text-align: center;line-height: 20px;margin-left: 10px;}
		
		.result .info{background-color: #fff;padding: 20px;box-sizing: border-box;}
		.result .info>.title{color: #29A7E1;font-size: 20px;line-height: 24px;border-bottom: 1px solid rgba(0, 0, 0, 0.1);padding-bottom:20px;}
		.result .info>.title>img{width: 7px;height: 24px;margin-right: 10px;}
		
		.result .info>.detail{height: 151px;padding: 20px;border: 1px solid rgba(0, 0, 0, 0.10);border-radius: 5px;box-sizing: border-box;}
		.result .info>.detail>div{margin: 8px 0px;}
		.result .info>.detail>.item1{display: flex;justify-content: space-between;}
		.result .info>.detail>.item1>.l>.bold{font-weight: bold;color: #333333;font-size: 16px;}
		.result .info>.detail>.item1>.l>.text{color: #666666;font-size: 16px;margin-right: 80px;}
		.result .info>.detail>.item1>.r{color: #999999;}
		.result .info>.detail>.item2{}
		.result .info>.detail>.item2>div>.bold{font-weight: bold;color: #333333;font-size: 16px;}
		.result .info>.detail>.item2>div>.text{color: #666666;font-size: 16px;margin-right: 80px;}
		.result .info>.detail>.item3{}
		.result .info>.detail>.item3>div{display: flex;}
		.result .info>.detail>.item3>div>.bold{font-weight: bold;color: #333333;font-size: 16px;flex-shrink: 0;}
		.result .info>.detail>.item3>div>.text{color: #666666;font-size: 16px;}
		
		.result .info>.chart{margin-top: 30px;}
		.result .info>.chart>.title{display: flex;justify-content: space-between;}
		.result .info>.chart>.title>.l{color: #29A7E1;font-size: 20px;line-height: 24px;}
		.result .info>.chart>.title>.l>img{width: 7px;height: 24px;margin-right: 10px;}
		.result .info>.chart>.title>.r{display: flex;}
		.result .info>.chart>.title>.r>div{display: flex;font-size:16px ;color: #333333;align-items: center;}
		.result .info>.chart>.title>.r>div>div{width: 36px;height: 20px;border-radius: 5px;margin-right: 6px;}
		.result .info>.chart>.title>.r>.item1{margin-right: 50px;}
		.result .info>.chart>.title>.r>.item1>div{background-color: #29A7E1;}
		.result .info>.chart>.title>.r>.item2>div{background-color: #FE9603;}
		.result .info>.chart>.content{width: 100%;height: 421px;}
	}
	@media (min-width: 1200px) {
		
		.result .center{background-color: #FBFBFB;}
		.result .detail{}
		.result .detail>.img{background-color: #fff;padding: 25px 0px 20px 0px;margin-bottom: 10px;}
		.result .detail>.img>img{width: 102px;height: 102px;border-radius: 50%;display: block;margin: 0px auto;}
		.result .detail>.img>.text{text-align: center;color: #333333;font-size: 16px;}
		.result .detail>.list{padding: 20px 0px 20px 0px;background-color: #fff;}
		.result .detail>.list>.item{display: flex;height: 60px;align-items: center;padding-left: 22px;box-sizing: border-box;width: 100%;cursor: pointer;border-left: 2px solid #00000000;transition: 0.3s;}
		.result .detail>.list>.active{background-color: #FBFBFB;border-left: 2px solid #F53824;}
		.result .detail>.list>.item>img{width: 44px;height: 44px;margin-right: 10px;}
		.result .detail>.list>.item>.text{font-size: 16px;color: #666;}
		.result .detail>.list>.item>.num{width: 28px;height: 23px;font-size: 16px;color: #fff;background-image: url("../images/user/label.png");background-size: 100% 100%;background-repeat: no-repeat;text-align: center;line-height: 20px;margin-left: 10px;}
		
		.result .info{background-color: #fff;padding: 20px;box-sizing: border-box;}
		.result .info>.title{color: #29A7E1;font-size: 20px;line-height: 24px;border-bottom: 1px solid rgba(0, 0, 0, 0.1);padding-bottom:20px;}
		.result .info>.title>img{width: 7px;height: 24px;margin-right: 10px;}
		
		.result .info>.detail{height: 151px;padding: 20px;border: 1px solid rgba(0, 0, 0, 0.10);border-radius: 5px;box-sizing: border-box;}
		.result .info>.detail>div{margin: 8px 0px;}
		.result .info>.detail>.item1{display: flex;justify-content: space-between;}
		.result .info>.detail>.item1>.l>.bold{font-weight: bold;color: #333333;font-size: 16px;}
		.result .info>.detail>.item1>.l>.text{color: #666666;font-size: 16px;margin-right: 80px;}
		.result .info>.detail>.item1>.r{color: #999999;}
		.result .info>.detail>.item2{}
		.result .info>.detail>.item2>div>.bold{font-weight: bold;color: #333333;font-size: 16px;}
		.result .info>.detail>.item2>div>.text{color: #666666;font-size: 16px;margin-right: 80px;}
		.result .info>.detail>.item3{}
		.result .info>.detail>.item3>div{display: flex;}
		.result .info>.detail>.item3>div>.bold{font-weight: bold;color: #333333;font-size: 16px;flex-shrink: 0;}
		.result .info>.detail>.item3>div>.text{color: #666666;font-size: 16px;}
		
		.result .info>.chart{margin-top: 30px;}
		.result .info>.chart>.title{display: flex;justify-content: space-between;}
		.result .info>.chart>.title>.l{color: #29A7E1;font-size: 20px;line-height: 24px;}
		.result .info>.chart>.title>.l>img{width: 7px;height: 24px;margin-right: 10px;}
		.result .info>.chart>.title>.r{display: flex;}
		.result .info>.chart>.title>.r>div{display: flex;font-size:16px ;color: #333333;align-items: center;}
		.result .info>.chart>.title>.r>div>div{width: 36px;height: 20px;border-radius: 5px;margin-right: 6px;}
		.result .info>.chart>.title>.r>.item1{margin-right: 50px;}
		.result .info>.chart>.title>.r>.item1>div{background-color: #29A7E1;}
		.result .info>.chart>.title>.r>.item2>div{background-color: #FE9603;}
		.result .info>.chart>.content{width: 100%;height: 421px;}
	}
	.container{width: 1500px}
	@media (max-width:1200px) {
		.container{width: auto;}
	}
</style>



// WEBPACK FOOTER //
// src/views/mine/h_wdceping1.vue